module.exports = __webpack_public_path__ + "images/175_2048.jpg";